"use client";

import { InsurancesSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedInsurancesSection from "../Components/GeneratedInsurancesSection";

const Insurances: FC<InsurancesSectionProps> = (props) => {
  return <GeneratedInsurancesSection {...props} />;
};

export default Insurances;
